// extracted by mini-css-extract-plugin
export var container = "GiftReview-module__container___GKHjw";
export var cardColumn = "GiftReview-module__cardColumn___AbvCB";
export var giftCard = "GiftReview-module__giftCard___jr2l5";
export var header = "GiftReview-module__header___A6_bx";
export var giftMessage = "GiftReview-module__giftMessage___ROdT4";
export var metadata = "GiftReview-module__metadata___yNceB";
export var infoContainer = "GiftReview-module__infoContainer___mQgP1";
export var value = "GiftReview-module__value___Yu0eC";
export var spacer = "GiftReview-module__spacer___aXJ6J";
export var printStyles = "GiftReview-module__printStyles___dPxlA";
export var metadataColumn = "GiftReview-module__metadataColumn___NWySY";